import React from 'react'
import './style.css'

const WelcomeBanner = () => {
    return (
        <>
            <div className="home-main-banner">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="home-banner-text">
                                <h1>Welcome to I-Sit</h1>
                                <p className='common-text'>Where Every Service Finds a Seat.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default WelcomeBanner